var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.334c.733 0 1.333-.6 1.333-1.334 0-.733-.6-1.333-1.333-1.333S.667 1.267.667 2c0 .734.6 1.334 1.333 1.334Zm0 1.333c-.733 0-1.333.6-1.333 1.333 0 .734.6 1.334 1.333 1.334S3.333 6.734 3.333 6c0-.733-.6-1.333-1.333-1.333Zm0 4c-.733 0-1.333.6-1.333 1.334 0 .733.6 1.333 1.333 1.333s1.333-.6 1.333-1.333c0-.734-.6-1.334-1.333-1.334Z",
    fill: "#5A88C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.c79636dc86406adfcda84a76dd44d6b1.svg";
export { ForwardRef as ReactComponent };